import type { VFC } from "react";

import { style } from "./index.styles";

type Props = {
  unread: boolean;
  className?: string;
};

export const UnreadBadge: VFC<Props> = (props) => {
  const read = !props.unread;
  return <span css={style(read)} className={props.className}></span>;
};
